import type { PopoverClassKey, PopoverOrigin } from '@mui/material/Popover';
import type { PopperPlacementType } from '@mui/material/Popper';

import type { TraceProps, WithTrace } from '../../utils';
import type { useStyles } from './Menu.styles';

export interface AnchorPos {
    top: number;
    left: number;
}

export enum AnchorReference {
    anchorEl,
    anchorPosition,
    none,
}

export interface MenuItemConfig {
    key: string | number;
    ItemComponent: React.ComponentType<any>;
    selected?: boolean;
    action?: (key: string | number) => void;
    isDisabled?: () => boolean;
    itemProps?: any;
    divideAfter?: boolean;
    dividerClassName?: string;
}

export interface MenuGroupConfig {
    key?: string;
    label: string;
    optionIds: string[];
    collapsible?: boolean;
    collapsedDefault?: boolean;
}

export interface MenuProps {
    options: MenuItemConfig[];
    open: boolean;
    optionGroups?: MenuGroupConfig[];
    onClose?: any;
    anchorEl?: Element | null;
    anchorPosition?: AnchorPos;
    anchorReference?: 'anchorEl' | 'anchorPosition' | 'none';
    transformOrigin?: any;
    anchorOrigin?: PopoverOrigin;
    onContextMenu?: (event: any) => void;
    disableAutoFocusItem?: boolean;
    onBackdropClick?: (event: any) => void;
    popoverClasses?: Partial<Record<PopoverClassKey, string>>;
    popperClassName?: string;
    popperPlacement?: PopperPlacementType;
    children?: React.ReactNode;
    actionButton?: React.ReactNode;
    customHeight?: number;
}

export type MenuExtensionProps = { classes: ReturnType<typeof useStyles>['classes'] };

export type MenuComponentProps = MenuProps & MenuExtensionProps & WithTrace & TraceProps;

export interface MenuItemWithIconProps {
    IconElement: React.ComponentType<any>;
    label: string;
    loading?: boolean;
}

export type MenuItemWithIconComponentProps = MenuItemWithIconProps & WithTrace & TraceProps;
